import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import React, { Component } from 'react';
import { DataContact } from '../../../data/DataContact';
import { MaxLengths } from '../../../data/MaxLenghts.jsx';
import { Immocom } from '../../../specifique/immocom';
import { ComboBoxCivilite } from '../../ComboBox/ComboBoxCivilite';
import { EUITextField } from '../../EUI/EUITextField';
import { DetailsListContactDedoublonne } from '../../List/DetailsListContactDedoublonne';
import { DetailsListDenonciation } from '../../List/DetailsListDenonciation';
import { DetailsListOrigineContact } from '../../List/DetailsListOrigineContact';
import { DetailsListSouhait } from '../../List/DetailsListSouhait';
import { DetailsListSouhaitMaisonIndividuelle } from '../../List/DetailsListSouhaitMaisonIndividuelle';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../../Outils/MessageBars';
import PickerContact from '../../Picker/PickerContact';
import { PickerCPVille } from '../../Picker/PickerCPVille';
import { Timeline } from '../../Timeline/Timeline';
import { FicheContactHistorique } from '../FicheContactHistorique';
import { BlocContact } from './BlocContact';
import { BlocRgpd } from './BlocRgpd';
import './FicheContact.css';

/*
***************************************************************
 PROPS:

    idContact

    isOpen
    appelFicheContactEnModeCreation => cache le bouton Précédent
    // onRechargeFiche => DOIT TOUJOURS ETRE RENSEIGNEE => mode création de contact afin de rester sur le formulaire Contact avec rechargement de ses onglets // KP 30/12/19 - N'est plus utilisé

    onAnnuleFiche
    onEnregistrementFiche
    onAfficheOngletsSouhaitEtSouhaitMaisonIdividuelle => méthode parent permettant d'afficher les ongles Souhait et SouhaitMaisonIndividuelle lors de la création de la réservation
    //afin d'obliger le passage par Enregistrer du contact avant de poursuivre

    titre (facultatif)
    listeEtapesTimeline (facultatif) : si undefined alors on masque la timeline
    numEtape

    pasDAccesAuxSouhaits => == true on n'affiche pas le menu d'accès aux souhaits
    pasDAccesAuxSouhaitsMaisonIndividuelle => == true on n'affiche pas le menu d'accès aux souhaits Maison individuelle
    pasDAccesAuxDenonciations => == true on n'affiche pas le menu d'accès aux dénonciations
    pasDAccesAHistorique => == true on n'affiche pas le menu d'accès à l'historique

    
    //Mettre en place l'orientation Appartement ou Maison Individuelle
    //cela permettra de renseigner l'IdNature du souhait à créer lors de la création d'un contact
    idNature

    //****************************************************************************************************************************************************
    //mode sélection de souhait => ****** Mode création d'une réservation ******
    //****************************************************************************************************************************************************
    onSelectionSouhait => méthode utilisée par le parent pour récupérer l'IdContact et l'IdSouhait du souhait sélectionné
    modeSelectionDeSouhait => none, single, multiple

    //ne plus en tenir compte
    //si true on affichera un bouton dans la liste des souhaits qui permettra de sélectionner et renvoyer à la méthode onSelectionSouhait l'IdContact et l'IdSouhait du souhait sélectionné
    
    idLotCommercial => idLotCommercial du lot qu'on est en train de réserver - il nous permet de faire définir IdNature du souhait = IdNature du lotCommercial 
    idOperation => idOperation du lot
    //****************************************************************************************************************************************************


    //****************************************************************************************************************************************************
    //mode enregistrement du souhait avec idReservation passé en paramètre => ****** Mode modification d'une réservation ******
    //****************************************************************************************************************************************************
    modeMiseAJourDuSouhaitLieAReservation => si true on affichera le bouton Lier à la réservation
    idReservation => mode modification de la réservation
    idOperation => mode modification de la réservation
    onEnregistrementLiaisonEntreSouhaitEtReservation => appelée à l'issue de la maj du souhait avec idreservation
    //****************************************************************************************************************************************************

    //**************************
    //Appel depuis FicheReservation
    //**************************
    //suppressionSouhaitPossible --> Permet de ne pas supprimer de souhait si la réservation est vérouillée
    //appelDepuisReservation --> utilisé pour afficher la barre d'aide dans le contact et demander a l'utilisateur de selectionner un souhait pour passer a la suite + masquer bouton suppression

    appelDepuisOption --> utilisé pour masquer bouton suppression

***************************************************************
*/

export class FicheContact extends Component {

    static defaultState = {
        contact: {},
        enfant: {},
        idNature: 0,
        listeContactsDedoublonnes: [],
        listeEnfants: [],
        objetSouhaitSelectionne: {},
        onEstPasseParLaListeDeDedoublonnement: false,
        reloadOnDismiss: false, // Passé en paramètre à props.onAnnuleFiche, permet le rechargement des données uniquement si on modifie le contact
        /* --- */
        affichageAucuneDenonceExistePourMoi: false,
        affichageBlocageCarDenonceParAutreCommercialisateur: false,
        affichageContact: false,
        affichageDedoublonnement: true,
        affichageDenonciations: false,
        affichageDialogCreationDeContact: false,
        affichageHistorique: false,
        affichagelisteContactsDedoublonnes: false,
        affichageOrigineContact: false,
        affichageRGPD: false,
        //affichageSelectionTypeDeSouhait: false, // KP - 12/07/2023 : ne semble plus être utilisé
        affichageSouhaits: false,
        affichageSouhaitsMaisonIndividuelle: false,
        /* --- */
        peutAccederOrigineContact: false,
        peutAccederSouhaits: false,
        peutAccederSouhaitsMaisonIndividuelle: false,
        peutCreerContact: false,
        peutModifierCivilite: false,
        peutModifierContact: false,
        peutModifierContactSa: false,
        peutModifierCpVille: false,
        peutModifierCritereDeDedoublonnement: false,
        peutModifierPrenom: false,
        peutSupprimerContact: false,
        peutVisualiserFicheContact: false,
        /* --- */
        onActiveBoutonEnregistrer: false,
        //possedeUneReservationDejaValidee: false, // KP - 07/04/2023 : n'est plus utilisé ?
    };

    _creationContent() {

        const { appelDepuisReservation } = this.props;
        const { contact, listeEnfants, peutModifierContactSa, peutModifierCivilite, peutModifierPrenom, peutModifierCpVille, peutModifierCritereDeDedoublonnement } = this.state;

        let renderFooterContent = null;
        let onAfficheLesSouhaits = true;
        let onAfficheLesSouhaitsMaisonIndividuelle = true;
        let onAfficheLesDenonciations = true;
        let onAfficheLHistorique = true;
        let onAfficheLOrigineContact = true;
        let titrePanel = ((this.state.contact.idContact === undefined || this.state.contact.idContact === null) ? 'Création d\'un contact' : 'Edition du contact');

        //2 cas où on n'affiche pas le lien des souhaits
        if (this.props.pasDAccesAuxSouhaits !== undefined) {
            //on arrive de la liste des contacts
            onAfficheLesSouhaits = !this.props.pasDAccesAuxSouhaits;
        }
        //2 cas où on n'affiche pas le lien des souhaits Maison individuelle
        if (this.props.pasDAccesAuxSouhaitsMaisonIndividuelle !== undefined) {
            //on arrive de la liste des contacts
            onAfficheLesSouhaitsMaisonIndividuelle = !this.props.pasDAccesAuxSouhaitsMaisonIndividuelle;
        }
        //2 cas où on n'affiche pas le lien des dénonciations
        if (this.props.pasDAccesAuxDenonciations !== undefined) {
            //on arrive de la liste des contacts
            onAfficheLesDenonciations = !this.props.pasDAccesAuxDenonciations;
        }
        //2 cas où on n'affiche pas le lien des dénonciations
        if (this.props.pasDAccesAHistorique !== undefined) {
            //on arrive de la liste des contacts
            onAfficheLHistorique = !this.props.pasDAccesAHistorique;
        }

        onAfficheLesSouhaits = this.state.peutAccederSouhaits;
        onAfficheLesSouhaitsMaisonIndividuelle = this.state.peutAccederSouhaitsMaisonIndividuelle;
        onAfficheLOrigineContact = this.state.peutAccederOrigineContact;

        if (this.state.contact.idContact === undefined | this.state.contact.idContact === null) {
            //on est en mode création de contact
            onAfficheLesSouhaits = false;
            onAfficheLesSouhaitsMaisonIndividuelle = false;
            onAfficheLesDenonciations = false;
            onAfficheLHistorique = false;
            onAfficheLOrigineContact = false;
        }

        //let listDdnEnfants = []; // KP - 12/07/2023 : ne semble plus être utilisé

        if (this.state.affichageContact) {
            // KP - 12/07/2023 : ne semble plus être utilisé
            // let _this = this;
            //this.state.listeEnfants.forEach(function (value, index) {
            //    if (value !== null) {
            //        listDdnEnfants.push(<div className="ms-Grid-row">
            //            <div className="ms-Grid-col ms-sm12">
            //                <Label key={`labelDateNaissanceEnfant${index}`} className="labelDateNaissance">{Scriba.date().stringDateFormat(value, 'YYYY')}</Label>
            //                <IconButton key={`buttonDateNaissanceEnfant${index}`} iconProps={{ iconName: 'Delete' }} className="boutonSuppressionDateNaissance" onClick={() => _this._onSuppressionDateNaissanceEnfant(value)} />
            //            </div>
            //        </div>);
            //    }
            //})

            //On grise systematiquement si on est en modification. 
            //La V2 permettait d'éditer nom/prénom/civilité en mode modification --> dangereux car peut modifier completement un contact.
            renderFooterContent = this._onRenderFooterContentContact;
        }
        else if (this.state.affichageSouhaits) {
            renderFooterContent = this._onRenderFooterContentSouhait;
        }
        else if (this.state.affichageSouhaitsMaisonIndividuelle || this.state.affichageDenonciations || this.state.affichageHistorique || this.state.affichageOrigineContact) {
            renderFooterContent = this._onRenderFooterContentVide;
        }
        else if (this.state.affichageDedoublonnement) {
            renderFooterContent = this._onRenderFooterContentDedoublonnement;
            onAfficheLesSouhaits = false;
            onAfficheLesSouhaitsMaisonIndividuelle = false;
            onAfficheLesDenonciations = false;
            onAfficheLHistorique = false;
            onAfficheLOrigineContact = false;
        }
        else if (this.state.affichagelisteContactsDedoublonnes) {
            renderFooterContent = this._onRenderFooterContentContactsDedoublonnes;
            onAfficheLesSouhaits = false;
            onAfficheLesSouhaitsMaisonIndividuelle = false;
            onAfficheLesDenonciations = false;
            onAfficheLHistorique = false;
            onAfficheLOrigineContact = false;

            titrePanel = 'Liste des contacts trouvés';
        }
        else if (this.state.affichageRGPD) {
            renderFooterContent = this._onRenderFooterContentRGPD;
            onAfficheLesSouhaits = false;
            onAfficheLesSouhaitsMaisonIndividuelle = false;
            onAfficheLesDenonciations = false;
            onAfficheLHistorique = false;
            onAfficheLOrigineContact = false;
        }

        //Affichage des pivots en fct des droits
        if (onAfficheLHistorique && !this.state.peutVisualiserFicheContact) {
            onAfficheLHistorique = false;
        }

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText={titrePanel}
            isOpen={this.props.isOpen}
            onDismiss={this._onAnnulation}
            onOpen={() => this._onOpen()}
            onRenderFooterContent={renderFooterContent}
            styles={{ content: { height: "100%" } }}
            type={PanelType.extraLarge}
        >
            {this.props.listeEtapesTimeline !== undefined ? <Timeline listeEtapes={this.props.listeEtapesTimeline} etapeActive={this.props.numEtape} /> : null}

            <div className="h-100" ref={this.scrollVersLeHaut}>

                <nav className="navbar navbar-expand-lg navbar-light border-bottom">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavFicheContact" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavFicheContact">
                        <ul className="navbar-nav">
                            <li name="liContact" className={`nav-item itemNavigationContact ${(this.state.affichageContact ? 'active' : '')}`} onClick={this._onSelectionOnglet('affichageContact')}>CONTACT</li>
                            {!!onAfficheLesSouhaits && <li name="liSouhait" className={`nav-item itemNavigationContact ${(this.state.affichageSouhaits ? 'active' : '')}`} onClick={this._onSelectionOnglet('affichageSouhaits')}>SOUHAITS</li>}
                            {!!onAfficheLesSouhaitsMaisonIndividuelle && <li name="liSouhaitMaisonIndividuelle" className={`nav-item itemNavigationContact ${(this.state.affichageSouhaitsMaisonIndividuelle ? 'active' : '')}`} onClick={this._onSelectionOnglet('affichageSouhaitsMaisonIndividuelle')}>SOUHAITS MAISON IND.</li>}
                            {!!onAfficheLesDenonciations && <li name="liDenonciation" className={`nav-item itemNavigationContact ${(this.state.affichageDenonciations ? 'active' : '')}`} onClick={this._onSelectionOnglet('affichageDenonciations')}>DENONCIATIONS</li>}
                            {!!onAfficheLHistorique && <li name="liHistorique" className={`nav-item itemNavigationContact ${(this.state.affichageHistorique ? 'active' : '')}`} onClick={this._onSelectionOnglet('affichageHistorique')}>HISTORIQUE</li>}
                            {!!onAfficheLOrigineContact && <li name="liOrigineContact" className={`nav-item itemNavigationContact ${(this.state.affichageOrigineContact ? 'active' : '')}`} onClick={this._onSelectionOnglet('affichageOrigineContact')}>ORIGINE</li>}
                        </ul>
                    </div>
                </nav>

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                {!!this.state.affichageContact &&
                    <BlocContact
                        appelDepuisReservation={appelDepuisReservation}
                        contact={contact}
                        enfants={listeEnfants}
                        onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                        onDelayedChange={(contact, enfants) => this.setState({ contact, listeEnfants: enfants }, this._onVerificationFormulaire)}
                        peutModifierContactSa={peutModifierContactSa}
                        peutModifierCivilite={peutModifierCivilite}
                        peutModifierPrenom={peutModifierPrenom}
                        peutModifierCpVille={peutModifierCpVille}
                        peutModifierCritereDeDedoublonnement={peutModifierCritereDeDedoublonnement}
                        idReservation={this.props.idReservation}
                    />
                }

                {!!this.state.affichageSouhaits && this.props.modeSelectionDeSouhait !== undefined &&
                    <div name="divDetailsListSouhait">
                        <DetailsListSouhait
                            idContact={this.state.contact.idContact}
                            appelDepuisContact
                            modeSelectionDeSouhait={this.props.modeSelectionDeSouhait}
                            onSelectionSouhait={(e) => this._onSelectionSouhait(e)}
                            idLotCommercial={this.props.idLotCommercial}
                            idOperation={this.props.idOperation}
                            idReservation={this.props.idReservation}
                            //suppressionSouhaitPossible={this.props.suppressionSouhaitPossible}
                            appelDepuisReservation={this.props.appelDepuisReservation}
                        />
                    </div>
                }

                {!!this.state.affichageSouhaits && this.props.modeSelectionDeSouhait === undefined &&
                    <div name="divDetailsListSouhait">
                        <DetailsListSouhait
                            idContact={this.state.contact.idContact}
                            appelDepuisContact
                            appelDepuisReservation={this.props.appelDepuisReservation}
                        />
                    </div>
                }

                {!!this.state.affichageSouhaitsMaisonIndividuelle &&
                    <div name="divDetailsListSouhaitMaisonIndividuelle">
                        <DetailsListSouhaitMaisonIndividuelle
                            idContact={this.state.contact.idContact}
                            appelDepuisContact
                        />
                    </div>
                }

                {!!this.state.affichageDenonciations &&
                    <DetailsListDenonciation
                        idContact={this.state.contact.idContact}
                        appelDepuisContact
                    />
                }

                {!!this.state.affichageHistorique &&
                    <FicheContactHistorique
                        idContact={this.state.contact.idContact}
                        onAffichePanelContactHistorique={this.state.affichageHistorique}
                        onFermeFicheContactHistorique={() => this._onAnnulation()}
                    />
                }

                {!!this.state.affichageOrigineContact &&
                    <DetailsListOrigineContact idContact={this.state.contact.idContact} />
                }

                {!!this.state.affichageDedoublonnement &&
                    <div name="divDedoublonnement">
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg3" name="divCiviliteContact">
                                <ComboBoxCivilite
                                    onChange={(event, option) => this.setState(prev => ({ contact: { ...prev.contact, civilite: option.key } }))}
                                    required
                                    selectedKey={this.state.contact.civilite}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg3 uppercase" name="divNomContact">
                                <PickerContact
                                    idContact={this.state.contact.idContact}
                                    nomContact={this.state.contact.nom}
                                    onChange={(contact) => this._onChangePickerContact(contact)}
                                    onInputChange={(newValue) => this.setState(prev => ({ contact: { ...prev.contact, nom: newValue } }))}
                                    required
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg3 capitalize" name="divPrenomContact">
                                <EUITextField
                                    inputClassName="capitalize"
                                    label="Prénom"
                                    maxLength={MaxLengths.contact.prenom}
                                    onChange={(event, newValue) => this.setState(prev => ({ contact: { ...prev.contact, prenom: newValue } }))}
                                    removeMultipleSpaces
                                    removeSpecialCharacters
                                    required
                                    value={this.state.contact.prenom}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg3" name="divCPVilleContact">
                                <PickerCPVille
                                    label="CP - Ville"
                                    cp={this.state.contact.cp}
                                    villeAdministrative={this.state.contact.ville}
                                    onChange={(idVilleAdm, idDeptAdm, idRegionAdm, cp, ville) => this.setState(prev => ({ contact: { ...prev.contact, cp, ville } }))}
                                    required
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg3" name="divEmailContact">
                                <EUITextField
                                    label="Email"
                                    maxLength={MaxLengths.contact.email}
                                    onChange={(event, newValue) => this.setState(prev => ({ contact: { ...prev.contact, email: newValue } }))}
                                    value={this.state.contact.email}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg3" name="divTelContact">
                                <EUITextField
                                    label="Téléphone"
                                    maxLength={MaxLengths.contact.tel1}
                                    onChange={(event, newValue) => this.setState(prev => ({ contact: { ...prev.contact, tel1: newValue } }))}
                                    value={this.state.contact.tel1}
                                />
                            </div>
                        </div>
                    </div>
                }

                {!!this.state.affichagelisteContactsDedoublonnes &&
                    <DetailsListContactDedoublonne
                        civilite={this.state.contact.civilite}
                        nom={this.state.contact.nom}
                        prenom={this.state.contact.prenom}
                        cp={this.state.contact.cp}
                        email={this.state.contact.email}
                        tel1={this.state.contact.tel1}
                        onSelection={(idContactSelectionne) => this._onSelectionContactDedoublonne(idContactSelectionne)}
                    />
                }

                {this.state.affichageRGPD &&
                    <BlocRgpd
                        contact={contact}
                        onChange={(contact) => this.setState({ contact }, this._onVerificationFormulaire)}
                    />
                }

                <Dialog
                    hidden={!this.state.affichageDialogCreationDeContact}
                    onDismiss={this._onFermetureFenetreModalCreationDeContact}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Enregistrement Contact',
                        subText: 'L\'enregistrement du contact est effectué.'
                    }}
                    modalProps={{
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={this._onFermetureFenetreModalCreationDeContact} text="Fermer" />
                    </DialogFooter>
                </Dialog>

                <Dialog
                    hidden={!this.state.affichageBlocageCarDenonceParAutreCommercialisateur}
                    onDismiss={this._onFermetureFenetreBlocageCarDenonceParAutreCommercialisateur}
                    dialogContentProps={{
                        type: DialogType.largeHeader,
                        title: 'Dénonciation',
                        subText: 'Ce contact est déjà dénoncé par un autre commercialisateur, veuillez-vous rapprocher de votre correspondant chez Eiffage Immobilier'
                    }}
                    modalProps={{
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={this._onFermetureFenetreBlocageCarDenonceParAutreCommercialisateur} text="Fermer" />
                    </DialogFooter>
                </Dialog>

                <Dialog
                    hidden={!this.state.affichageAucuneDenonceExistePourMoi}
                    onDismiss={this._onFermetureFenetreAucuneDenonceExistePourMoi}
                    dialogContentProps={{
                        type: DialogType.largeHeader,
                        title: 'ATTENTION : Dénonciation',
                        subText: 'Vous n\'avez pas dénoncé ce contact ...'
                    }}
                    modalProps={{
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={this._onFermetureFenetreAucuneDenonceExistePourMoi} text="Ajouter dénonciation" />
                        <DefaultButton onClick={this._onFermetureFormulaire} text="Fermer" />
                    </DialogFooter>
                </Dialog>

                <Dialog
                    hidden={!this.state.affichageObligationRenseignementSouhait}
                    onDismiss={this._onFermetureObligationRenseignementSouhait}
                    dialogContentProps={{
                        type: DialogType.largeHeader,
                        title: 'ATTENTION',
                        subText: 'Vous devez compléter le souhait afin de pouvoir le lier à la réservation.'
                    }}
                    modalProps={{
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <DefaultButton onClick={this._onFermetureObligationRenseignementSouhait} text="Fermer" />
                    </DialogFooter>
                </Dialog>

                <Dialog
                    hidden={!this.state.onAfficheDialogSuppressionContact}
                    onDismiss={this._onCacheDialogSuppressionContact}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Suppression du contact',
                        subText: 'Attention, vous êtes en train de supprimer un contact, souhaitez-vous continuer ?'
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={this._onSuppressionContact} text="Supprimer" />
                        <DefaultButton onClick={this._onCacheDialogSuppressionContact} text="Annuler" />
                    </DialogFooter>
                </Dialog>

            </div>

        </Panel>;
    }

    constructor(props) {
        super(props);
        this.state = { ...FicheContact.defaultState };
        this.scrollVersLeHaut = React.createRef(); // On crée une référence que l'on attache a un élément du DOM
    };

    _onInit = () => {
        this.setState({ ...FicheContact.defaultState });
    };

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du contact en cours',
        });

        const idNature = this.props.idNature || this.state.idNature || 0;

        let onEnregistrementContact = DataContact._onEnregistrementContact(
            this.state.contact,
            this.state.listeEnfants,
            this.props.idOperation,
            this.props.idLotCommercial,
            this.props.idReservation,
            idNature);

        onEnregistrementContact
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this.setState({
                        reloadOnDismiss: true,
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarError: true,
                        errorMessage: '',
                        hideMessageBarWarning: true,
                        warningMessage: ''
                    });

                    let objetData = responseFetch.reponseAPIobjet[0];
                    let objetDenonciationCommercialisateurExistePourQQ1Autre = responseFetch.reponseAPIobjet[1];

                    if (objetDenonciationCommercialisateurExistePourQQ1Autre !== null) {
                        //on bloque, on ne va pas plus loin car il existe une dénonciation pour un autre commercialisateur et qu'on a que le droit 'Contact_VoitSesContacts'
                        const state = { affichageBlocageCarDenonceParAutreCommercialisateur: true };
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                    }
                    else {
                        //création de contact
                        const modeCreationDeContact = this.state.contact.idContact == null;
                        if (modeCreationDeContact) {
                            let affichageDialogCreationDeContact = true;
                            if (this.props.appelDepuisOption)
                                affichageDialogCreationDeContact = false;

                            const contact = { ...this.state.contact, idContact: objetData.idContact };
                            const state = { contact, affichageDialogCreationDeContact };
                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                        }

                        //si idOperation et idLotCommercial sont renseignés => on arrive de la réservation
                        if (this.props.appelDepuisReservation === true) {
                            if (this.props.onAfficheOngletsSouhaitEtSouhaitMaisonIdividuelle != undefined)
                                this.props.onAfficheOngletsSouhaitEtSouhaitMaisonIdividuelle();
                        }

                        if (this.props.appelDepuisOption === true) {
                            //on ne vérifie pas si le contact lui appartient car il vient de le créer et il lui appartient automatiquement
                            this.props.onEnregistrementFiche(objetData.idContact);
                        }
                    }

                    // KP - 2481 - 12/07/2023 : afficher un warning dans le cas ou le message concerne une éventuelle duplication du contact
                    if (responseFetch.message !== "ok")
                        this.setState({ warningMessage: responseFetch.messageInfo });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });

        //Scroll vers le haut automatique
        this.scrollVersLeHaut.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    // KP - 2023/03/21 - 2332 : mise à jour isolée car doit pouvoir s'exécuter même si formulaire invalide
    _onEnregistrementVisualerLeContact = () => {
        const { idContact } = this.props;
        if (!!idContact)
            DataContact._onEnregistrementVisualerLeContact(idContact).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    let contact = { ...this.state.contact };
                    contact.visualiserLe = new Date();
                    this.setState({ contact });
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
    };

    _onEnregistrementLiaisonEntreSouhaitEtReservation = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du souhait en cours'
        });

        let onEnregistrementLiaisonEntreSouhaitEtReservation = DataContact._onEnregistrementLiaisonEntreSouhaitEtReservation(
            this.props.idReservation,
            this.props.idOperation,
            this.state.objetSouhaitSelectionne._items[0].idContact,
            this.state.objetSouhaitSelectionne._items[0].idSouhait);

        onEnregistrementLiaisonEntreSouhaitEtReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    let objetData = responseFetch.reponseAPIobjet;

                    this.props.onEnregistrementLiaisonEntreSouhaitEtReservation(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onChangeSelectionTypeDeSouhait = (ev, option) => {
        this.setState({
            idNature: option.key
        });
    }

    _onFermetureFenetreModalCreationDeContact = () => {
        this.setState({
            affichageDialogCreationDeContact: false
        });
    }

    _onFermetureFenetreBlocageCarDenonceParAutreCommercialisateur = () => {
        this.setState({
            affichageBlocageCarDenonceParAutreCommercialisateur: false
        });

        this._onFermetureFormulaire();
    }

    _onFermetureFenetreAucuneDenonceExistePourMoi = () => {
        if (this.props.appelDepuisOption === true) {
            this.props.onEnregistrementFiche(this.state.contact.idContact);
        }
        else {
            this.setState({
                affichageContact: false,
                affichageSouhaits: false,
                affichageSouhaitsMaisonIndividuelle: false,
                affichageDenonciations: true,
                affichageHistorique: false,
                affichageOrigineContact: false,
                affichageAucuneDenonceExistePourMoi: false
            });
        }
    }

    _onFermetureObligationRenseignementSouhait = () => {
        this.setState({
            affichageObligationRenseignementSouhait: false
        });
    }

    _onAffichageDialogSuppressionContact = () => {
        this.setState({
            onAfficheDialogSuppressionContact: true
        });
    }

    _onCacheDialogSuppressionContact = () => {
        this.setState({
            onAfficheDialogSuppressionContact: false
        });
    }

    _onVerification = () => {
        if (this._estValideFormulaireDedoublonnement()) {
            this._onSuivant();
        }
    }

    _onOpen = () => {
        const idContact = this.props.idContact || null;
        const contact = { ...this.state.contact, idContact };
        const titrePanelContact = this.props.titre || "Fiche contact";
        this.setState(
            { contact, titrePanelContact },
            !!idContact ? this._chargementDuContactPlusDroit : this._chargementDroits
        );
    };

    _onAnnulation = () => {
        this._onFermetureFormulaire();
    }

    _onFermetureFormulaire = () => {
        const { onAnnuleFiche } = this.props;
        const { reloadOnDismiss } = this.state;
        this._onInit();
        if (!!onAnnuleFiche && typeof onAnnuleFiche === "function") onAnnuleFiche(reloadOnDismiss);
    };

    _onSelectionContactDedoublonne = (idContactSelectionne) => {
        if (!!idContactSelectionne) { // Si clic sur contact déjà existant
            const entreeDeFormulaire = true;
            this._onVerificationSiDenonciationExiste(idContactSelectionne, entreeDeFormulaire);
        }
        else {
            const contact = this._chargementObjetContactAvecLeState();
            const state = { contact };
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onSuivant);
        }
    };

    //testEntreeDeFormulaire => ==true => appel en entrée de formulaire ; == false => appel lors de la sortie du formulaire
    //sur création simple de contact et sur création de contact dans le cadre d'un passage de résea ou d'option
    _onVerificationSiDenonciationExiste = (idContactSelectionne, testEntreeDeFormulaire) => {
        const { appelDepuisOption, idOperation } = this.props;
        console.log("_onVerificationSiDenonciationExiste")

        let proceed = true;
        if (appelDepuisOption) proceed = false; //rustine : si on est appelé de l'option on n'effectue pas cette action
        if (testEntreeDeFormulaire) proceed = true;

        if (proceed) {
            DataContact._onRegardeSiExisteDenonciationPourUnAutreCommercialisateurEtPourMoi(idContactSelectionne, idOperation).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {

                    const data = responseFetch.reponseAPIobjet;
                    const objetDenonciationValideAutreCommercialisateur = data[0];
                    const objetDenonciationPourMoi = data[1];
                    const voitSesContacts = data[2];

                    if (objetDenonciationValideAutreCommercialisateur == null && objetDenonciationPourMoi == null && voitSesContacts == null) {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                        this._onFermetureFormulaire();
                    }
                    else {
                        //=> gestion en fonction de ses dénonciations, sinon c'est en fct de son périmètre et dans ce cas là pas besoin de faire de vérification si le contact est dénoncé
                        if (voitSesContacts) {
                            if (testEntreeDeFormulaire) {
                                if (objetDenonciationValideAutreCommercialisateur && !objetDenonciationPourMoi) {
                                    const state = {
                                        affichageDialogCreationDeContact: false,
                                        affichageBlocageCarDenonceParAutreCommercialisateur: true
                                    };
                                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                                }
                                else if (!objetDenonciationValideAutreCommercialisateur) {
                                    //on recharge la fiche contact avec le contact sélectionné
                                    const contact = {
                                        ...this.state.contact,
                                        idContact: idContactSelectionne
                                    };
                                    const state = { contact };
                                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onSuivant);
                                }
                            }
                            else {
                                //on est en sortie du formulaire
                                if (objetDenonciationValideAutreCommercialisateur && !objetDenonciationPourMoi) {
                                    const state = {
                                        affichageDialogCreationDeContact: false,
                                        affichageBlocageCarDenonceParAutreCommercialisateur: true
                                    };
                                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                                }
                                else if (!objetDenonciationPourMoi) {
                                    //ouverture panel de dénonciation
                                    const state = {
                                        affichageDialogCreationDeContact: false,
                                        affichageAucuneDenonceExistePourMoi: true
                                    };
                                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                                }
                                else this._onFermetureFormulaire();
                            }
                        }
                        else {
                            if (testEntreeDeFormulaire) {
                                const contact = {
                                    ...this.state.contact,
                                    idContact: idContactSelectionne
                                };
                                const state = { contact };
                                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onSuivant);
                            }
                            else this._onFermetureFormulaire();
                        }
                    }
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
        }
    };

    _isDisabledBoutonSelectionSouhait = () => {
        const obj = this.state.objetSouhaitSelectionne;
        return !(obj && obj._items && obj._items[0] && obj._items[0].idSouhait);
    };

    _onChangePickerContact = (contact) => {
        if (!contact) contact = {};
        const { civilite, nom, prenom, cp, ville, email, tel1 } = contact;
        const idContact = null;
        this.setState({ contact: { idContact, civilite, nom, prenom, cp, ville, email, tel1 } });
    };

    _onSelectionSouhait = (objet) => {
        let stateUpdates = {
            objetSouhaitSelectionne: {},
            affichageObligationRenseignementSouhait: false,
        };

        if (objet != null) {
            if (
                objet._items[0].idSouhait !== null && objet._items[0].idSouhait !== undefined &&
                objet._items[0].rechercheMotifAcquisition !== '' && objet._items[0].rechercheMotifAcquisition !== null &&
                objet._items[0].rechercheOrigineCommerciale !== '' && objet._items[0].rechercheOrigineCommerciale !== null
            ) { //getSelection()[0]
                //valeurs vides => voir comment récupérer ces valeurs
                stateUpdates.objetSouhaitSelectionne = objet;
            }
            else {
                stateUpdates.affichageObligationRenseignementSouhait = true;
            }
        }

        this.setState(stateUpdates);
    }

    _onReturnSouhait = () => {
        this.props.onSelectionSouhait(this.state.objetSouhaitSelectionne);
        this._onAnnulation();
    }

    _onPrecedent = () => {
        let stateUpdates = {
            affichageContact: false,
            affichageSouhaits: false,
            affichageSouhaitsMaisonIndividuelle: false,
            affichageHistorique: false,
            affichageOrigineContact: false,
            affichageDedoublonnement: false,
            affichagelisteContactsDedoublonnes: false,
            affichageRGPD: false,

            //affichageSelectionTypeDeSouhait: false, // KP - 12/07/2023 : ne semble plus être utilisé
            affichageDialogCreationDeContact: false,
            affichageBlocageCarDenonceParAutreCommercialisateur: false,
            affichageAucuneDenonceExistePourMoi: false,
        };

        if (this.state.affichagelisteContactsDedoublonnes) { // Page actuelle = liste des contacts dédoublonnés
            stateUpdates.affichageDedoublonnement = true;
            stateUpdates.onEstPasseParLaListeDeDedoublonnement = false;
        }
        else if (this.state.affichageRGPD) { // Page actuelle = formulaire RGPD
            if (this.state.onEstPasseParLaListeDeDedoublonnement) stateUpdates.affichagelisteContactsDedoublonnes = true;
            else stateUpdates.affichageDedoublonnement = true;
        }
        else if (this.state.affichageContact) { // Page actuelle = formulaire de création/modification d'un contact
            if (this.state.onEstPasseParLaListeDeDedoublonnement)
                if (this.state.contact.idContact != null) {
                    let contact = { ...this.state.contact };
                    contact.idContact = null;

                    stateUpdates.affichagelisteContactsDedoublonnes = true;
                    stateUpdates.contact = contact;

                    //this.props.onRechargeFiche(null); // A checker si réellement nécessaire
                }
                else stateUpdates.affichageRGPD = true;
            else
                if (this.state.contact.idContact != null) {
                    let contact = { ...this.state.contact };
                    contact.idContact = null;

                    stateUpdates.affichagelisteContactsDedoublonnes = true;
                    stateUpdates.contact = contact;
                }
                else stateUpdates.affichageRGPD = true;
        }
        this.setState(stateUpdates);
    }

    _onSuivant = async () => {

        let stateUpdates = {
            affichageContact: false,
            affichageSouhaits: false,
            affichageSouhaitsMaisonIndividuelle: false,
            affichageHistorique: false,
            affichageOrigineContact: false,
            affichageDedoublonnement: false,
            affichagelisteContactsDedoublonnes: false,
            affichageRGPD: false,

            affichageDialogCreationDeContact: false,
            affichageBlocageCarDenonceParAutreCommercialisateur: false,
            affichageAucuneDenonceExistePourMoi: false,

            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            hideMessageBarError: true,
            errorMessage: ''
        };

        if (this.state.affichageDedoublonnement) {
            await DataContact._onGetSiContactExiste(this.state.contact).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const listeContactsDedoublonnes = responseFetch.reponseAPIobjet;
                    //il existe plusieurs contacts identiques trouvés
                    //on prend >1 car je renvoie une première ligne avec 'nouveau contact'
                    if (listeContactsDedoublonnes.length > 1) {
                        const contact = { ...this.state.contact, idContact: null };
                        stateUpdates.affichagelisteContactsDedoublonnes = true;
                        stateUpdates.contact = contact;
                        stateUpdates.listeContactsDedoublonnes = listeContactsDedoublonnes;
                        stateUpdates.onEstPasseParLaListeDeDedoublonnement = true;
                    }
                    else stateUpdates.affichageRGPD = true;
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            })
        }
        else if (this.state.affichagelisteContactsDedoublonnes) {
            if (this.state.contact.idContact == null) stateUpdates.affichageRGPD = true;
            else {
                //---------------------------------------------------------------
                //AF - Rechargement de l'objet contact lors de la selection depuis la liste des contacts dédoublonnés
                //---------------------------------------------------------------
                await DataContact._chargementContact(this.state.contact.idContact).then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        stateUpdates.contact = responseFetch.reponseAPIobjet[0];
                        stateUpdates.affichageContact = true;
                    }
                    else this._onTraitementErreur(retourVerif, responseFetch);
                })
            }
        }
        else if (this.state.affichageRGPD) stateUpdates.affichageContact = true;

        this.setState(stateUpdates, this._onVerificationFormulaire);

    };

    _estValideFormulaireDedoublonnement = () => {
        const { contact } = this.state;
        if (!contact) return false;
        else {
            const { civilite, nom, prenom, cp } = contact;
            if (!civilite || civilite === "0") return false;
            if (!nom || !prenom || !cp) return false;
        }
        return true;
    };

    _chargementObjetContactAvecLeState = () => {
        const { civilite, nom, prenom, cp, ville, email, tel1 } = this.state.contact;
        const idContact = null;
        const contact = { idContact, civilite, nom, prenom, cp, ville, email, tel1 };
        return contact;
    };

    _chargementDuContactPlusDroit = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du contact'
        });

        DataContact._chargementContact(this.state.contact.idContact).then(responseFetch => {

            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let retourData = responseFetch.reponseAPIobjet;

                let itemContact = retourData[0];
                let peutCreerContact = retourData[1];
                let peutModifierContact = retourData[2];
                let peutVisualiserFicheContact = retourData[3];
                let peutAccederSouhaits = retourData[4]; //a un mandat de type de programme correspondant au souhait normal
                let peutAccederSouhaitsMaisonIndividuelle = retourData[5]; //a un mandat de type de programme correspondant au souhait maison individuelle
                let peutSupprimerContact = retourData[6];
                let peutModifierContactSa = retourData[7];
                let peutModifierCritereDeDedoublonnement = retourData[9];
                let peutAccederOrigineContact = retourData[11];
                let peutModifierCivilite = retourData[12];
                let peutModifierPrenom = retourData[13];
                let peutModifierCpVille = retourData[14];

                let listEnfants = [];

                if (itemContact.dateNaissanceEnfant1 !== null) {
                    listEnfants.push(itemContact.dateNaissanceEnfant1);
                }
                if (itemContact.dateNaissanceEnfant2 !== null) {
                    listEnfants.push(itemContact.dateNaissanceEnfant2);
                }
                if (itemContact.dateNaissanceEnfant3 !== null) {
                    listEnfants.push(itemContact.dateNaissanceEnfant3);
                }
                if (itemContact.dateNaissanceEnfant4 !== null) {
                    listEnfants.push(itemContact.dateNaissanceEnfant4);
                }
                if (itemContact.dateNaissanceEnfant5 !== null) {
                    listEnfants.push(itemContact.dateNaissanceEnfant5);
                }

                //Suppression des espaces à l'affichage --> Cela ne declenche pas le message d'erreur 
                itemContact.tel1 = (itemContact.tel1 !== null ? itemContact.tel1.replace(/\s/g, '') : "");
                itemContact.tel2 = (itemContact.tel2 !== null ? itemContact.tel2.replace(/\s/g, '') : "");
                //-------------------------------------

                const idContactRenseigne = !!this.props.idContact;

                let stateTemp = {
                    contact: itemContact,
                    listeEnfants: listEnfants,
                    peutCreerContact,
                    peutModifierContact,
                    peutSupprimerContact,
                    peutVisualiserFicheContact,
                    peutAccederSouhaits,
                    peutAccederSouhaitsMaisonIndividuelle,
                    peutAccederOrigineContact,
                    affichageContact: idContactRenseigne, // Si this.props.idContact existe alors omettre étape dédoublonnement
                    affichageSouhaits: false,
                    affichageSouhaitsMaisonIndividuelle: false,
                    affichageDedoublonnement: !idContactRenseigne, // Si this.props.idContact n'existe pas alors proposer le dédoublonnement
                    affichageHistorique: false,
                    affichageOrigineContact: false,
                    affichagelisteContactsDedoublonnes: false,
                    affichageRGPD: false,
                    onEstPasseParLaListeDeDedoublonnement: false,
                    peutModifierContactSa,
                    peutModifierCivilite,
                    peutModifierPrenom,
                    peutModifierCpVille,
                    peutModifierCritereDeDedoublonnement,
                };

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);

                // KP - 21/03/2023 - 2332 : si chargement du contact ok, alors mettre à jour champ VisualiserLe
                if (!itemContact.visualiserLe)
                    this._onEnregistrementVisualerLeContact();
            }
            else {
                let stateTemp = {};
                stateTemp.contact = {};
                stateTemp.peutCreerContact = false;
                stateTemp.peutModifierContact = false;
                stateTemp.peutSupprimerContact = false;
                stateTemp.peutVisualiserFicheContact = false;
                stateTemp.peutModifierCivilite = false;
                stateTemp.peutModifierPrenom = false;
                stateTemp.peutModifierCpVille = false;
                stateTemp.peutModifierCritereDeDedoublonnement = false;

                stateTemp.affichageContact = false;
                stateTemp.affichageSouhaits = false;
                stateTemp.affichageSouhaitsMaisonIndividuelle = false;
                stateTemp.affichageDedoublonnement = true;
                stateTemp.affichageHistorique = false;
                stateTemp.affichageOrigineContact = false;
                stateTemp.affichagelisteContactsDedoublonnes = false;
                stateTemp.affichageRGPD = false;
                stateTemp.onEstPasseParLaListeDeDedoublonnement = false;
                stateTemp.peutModifierContactSa = false;
                //stateTemp.possedeUneReservationDejaValidee = false;

                Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
            }
        });
    };

    _chargementDroits = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des droits'
        });

        let chargementListeDesDroitsFicheContact = DataContact._chargementListeDesDroitsFicheContact();
        chargementListeDesDroitsFicheContact
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let listDroits = responseFetch.reponseAPIobjet;
                    let peutCreerContact = listDroits[0];
                    let peutModifierContact = listDroits[1];
                    let peutVisualiserFicheContact = listDroits[2];
                    let peutAccederSouhaits = listDroits[3]; //a un mandat de type de programme correspondant au souhait normal
                    let peutAccederSouhaitsMaisonIndividuelle = listDroits[4]; //a un mandat de type de programme correspondant au souhait maison individuelle
                    let peutSupprimerContact = listDroits[6];
                    let peutModifierCritereDeDedoublonnement = listDroits[7];

                    let stateTemp = {};
                    stateTemp.contact = {};
                    stateTemp.droitsCharges = true;
                    stateTemp.peutCreerContact = peutCreerContact;
                    stateTemp.peutModifierContact = peutModifierContact;
                    stateTemp.peutSupprimerContact = peutSupprimerContact;
                    stateTemp.peutVisualiserFicheContact = peutVisualiserFicheContact;
                    stateTemp.peutAccederSouhaits = peutAccederSouhaits;
                    stateTemp.peutAccederSouhaitsMaisonIndividuelle = peutAccederSouhaitsMaisonIndividuelle;
                    stateTemp.peutModifierCritereDeDedoublonnement = peutModifierCritereDeDedoublonnement;

                    stateTemp.affichageContact = this.state.onEstPasseParLaListeDeDedoublonnement;
                    stateTemp.affichageSouhaits = false;
                    stateTemp.affichageSouhaitsMaisonIndividuelle = false;
                    stateTemp.affichageDedoublonnement = !this.state.onEstPasseParLaListeDeDedoublonnement;
                    stateTemp.affichageHistorique = false;
                    stateTemp.affichageOrigineContact = false;
                    stateTemp.affichagelisteContactsDedoublonnes = false;
                    stateTemp.affichageRGPD = false;
                    stateTemp.onEstPasseParLaListeDeDedoublonnement = false;
                    stateTemp.hideMessageBarFiltres = (responseFetch.messageInfo === "" || responseFetch.messageInfo === null);
                    stateTemp.messageMessageBarFiltres = responseFetch.messageInfo;
                    stateTemp.peutModifierContactSa = false;
                    //stateTemp.possedeUneReservationDejaValidee = false;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    let stateTemp = {};
                    stateTemp.contact.idContact = null;
                    stateTemp.contact.civilite = '0';
                    stateTemp.contact.nom = null;
                    stateTemp.contact.prenom = null;
                    stateTemp.contact.cp = null;
                    stateTemp.contact.ville = null;

                    stateTemp.peutCreerContact = false;
                    stateTemp.peutModifierContact = false;
                    stateTemp.peutSupprimerContact = false;
                    stateTemp.peutVisualiserFicheContact = false;
                    stateTemp.peutModifierCritereDeDedoublonnement = false;

                    stateTemp.affichageContact = this.state.onEstPasseParLaListeDeDedoublonnement;
                    stateTemp.affichageSouhaits = false;
                    stateTemp.affichageSouhaitsMaisonIndividuelle = false;
                    stateTemp.affichageDedoublonnement = !this.state.onEstPasseParLaListeDeDedoublonnement;
                    stateTemp.affichageHistorique = false;
                    stateTemp.affichageOrigineContact = false;
                    stateTemp.affichagelisteContactsDedoublonnes = false;
                    stateTemp.affichageRGPD = false;
                    stateTemp.onEstPasseParLaListeDeDedoublonnement = false;
                    stateTemp.peutModifierContactSa = false;
                    //stateTemp.possedeUneReservationDejaValidee = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _onSuppressionContact = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression du contact en cours'
        });

        let onSuppressionContact = DataContact._onSuppressionContact(this.state.contact.idContact);
        onSuppressionContact
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let stateTemp = {};
                    stateTemp.onAfficheDialogSuppressionContact = false;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                    this.props.onEnregistrementFiche();
                }
                else {
                    let stateTemp = {};
                    stateTemp.onAfficheDialogSuppressionContact = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _onRenderFooterContentContact = () => {
        let disabledButtonEnregistrement = !this.state.affichageContact;
        let disabledButtonSuppression = !this.state.affichageContact;

        disabledButtonEnregistrement = !this.state.onActiveBoutonEnregistrer;

        if (!this.state.peutModifierContact && this.props.idContact !== null) {
            disabledButtonEnregistrement = true;
            disabledButtonSuppression = true;
        }

        if (!this.state.peutCreerContact && this.props.idContact === null) {
            disabledButtonEnregistrement = true;
        }

        if (!this.state.peutSupprimerContact && this.props.idContact === null) {
            disabledButtonSuppression = true;
        }

        let styleBoutonPrecedent = {};

        if (this.props.appelFicheContactEnModeCreation) {
            styleBoutonPrecedent = { marginRight: '8px' };
        }
        else {
            styleBoutonPrecedent = { display: 'none', marginRight: '8px' };
        }

        let hiddenBoutonSupprimer = false;
        if (this.props.appelDepuisReservation || //Réservation
            this.props.appelDepuisOption || //Option
            !this.state.contact.idContact)  //Prospection en mode création
        {
            hiddenBoutonSupprimer = true;
        }

        return (
            <div>
                <DefaultButton onClick={() => this._onPrecedent()} style={styleBoutonPrecedent}>Précédent</DefaultButton>
                <PrimaryButton name="EnregistrerContact" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={disabledButtonEnregistrement}>Enregistrer</PrimaryButton>
                <PrimaryButton onClick={() => this._onAffichageDialogSuppressionContact()} className="marginRight8px" disabled={disabledButtonSuppression} hidden={hiddenBoutonSupprimer}>Supprimer</PrimaryButton>
                <DefaultButton name="AnnulerEnregistrementContact" onClick={this._onAnnulation}>Annuler</DefaultButton>
            </div>
        );
    };

    _onRenderFooterContentSouhait = () => {
        let disabledButton = this._isDisabledBoutonSelectionSouhait();

        if ((this.props.modeSelectionDeSouhait !== undefined && this.props.modeSelectionDeSouhait !== 'none') && !this.props.modeMiseAJourDuSouhaitLieAReservation) {
            return (
                <div>
                    <PrimaryButton name="selectionnerSouhait" className="zindex2000 marginRight8px" onClick={() => this._onReturnSouhait()} disabled={disabledButton}>Sélectionner</PrimaryButton>
                    <DefaultButton className="zindex2000" onClick={this._onAnnulation}>Annuler</DefaultButton>
                </div>
            );
        }
        else if (this.props.modeMiseAJourDuSouhaitLieAReservation) {
            return (
                <div>
                    <PrimaryButton className="zindex2000 marginRight8px" onClick={() => this._onEnregistrementLiaisonEntreSouhaitEtReservation()} disabled={disabledButton}>Lier à la réservation</PrimaryButton>
                    <DefaultButton className="zindex2000" onClick={this._onAnnulation}>Annuler</DefaultButton>
                </div>
            );
        }
        else {
            return (<div></div>);
        }
    };

    _onRenderFooterContentVide = () => <div />;

    _onRenderFooterContentDedoublonnement = () => {
        const disabled = !this._estValideFormulaireDedoublonnement();
        return <div>
            <PrimaryButton name="SuivantDedoublonnement" onClick={this._onVerification} className="marginRight8px" disabled={disabled}>Suivant</PrimaryButton>
            <DefaultButton onClick={this._onAnnulation}>Annuler</DefaultButton>
        </div>;
    };

    _onRenderFooterContentContactsDedoublonnes = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onPrecedent()} className="marginRight8px">Précédent</DefaultButton>
                <DefaultButton onClick={this._onAnnulation}>Annuler</DefaultButton>
            </div>
        );
    };

    _onRenderFooterContentRGPD = () => {
        let disabledButton = !this.state.contact.consentementCollecteDonneesPersonnelles;

        return (
            <div>
                <DefaultButton onClick={() => this._onPrecedent()} className="marginRight8px">Précédent</DefaultButton>
                <PrimaryButton name="SuivantConsentementCollecteDonneesPersonnelles" onClick={this._onSuivant} className="marginRight8px" disabled={disabledButton}>Suivant</PrimaryButton>
                <DefaultButton onClick={this._onAnnulation}>Annuler</DefaultButton>
            </div>
        );
    };

    _onSelectionOnglet = (stateAttributeName) => () => {
        let state = {
            affichageContact: false,
            affichageDenonciations: false,
            affichageHistorique: false,
            affichageOrigineContact: false,
            affichageSouhaits: false,
            affichageSouhaitsMaisonIndividuelle: false,
        };
        state[stateAttributeName] = true;
        if (stateAttributeName === 'affichageSouhaits') state.objetSouhaitSelectionne = {};
        this.setState(state);
    };

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, 'Contact', this.state.contact, (this.state.contact.idContact > 0 ? 'Modification' : 'Création'));
    };

    componentDidUpdate() {
        if (this.state.contact.consentementDiffusionDonneesPersonnelles === undefined) {
            let contactTrav = { ...this.state.contact };
            contactTrav.consentementDiffusionDonneesPersonnelles = true;
            this.setState({ contact: contactTrav });
        }
    }

    render = () => {
        return this._creationContent();
    };

};